export default function CameraFollowMotionIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7 2.75H2.75V7M15 2.75H19.25V7M7 19.25H2.75V15M15 19.25H19.25V15"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="11" cy="11" r="2.6" fill="currentColor" />
    </svg>
  );
}
